import { Col, Row } from 'antd';
import { InputComponent } from 'components/common/Input';
import { INPUT_TYPE, LABEL_TYPE } from 'components/common/Input/types';
import { capitalize } from 'lodash';
import React, { useCallback } from 'react';
import IntlMessages from 'utils/IntlMessages';

import { ActionButtonStyled, WarningMessageStyled } from '../styled';
import AvailabilityDayForm from './AvailabilityDayForm';
import { AvailabilityTimesContainerStyled, WarningMessageContainerStyled } from './styled';
import { AvailableTimeType, IAvailabilityDayProps } from './types';

const availableTimeTypeOptions = [
  { value: 'anytime', label: 'Anytime' },
  { value: 'specific', label: 'Specific Time' },
];

const availableTimeTypeRadionputSettings = { rowDisplay: true };

const AvailabilityDay: React.FC<IAvailabilityDayProps> = ({
  dayData,
  currentDay,
  dayIndex,
  handleAddAvailabilityTime,
  handleAvailabilitySwitchChange,
  handleClearTime,
  handlePickTime,
  currentDayInvalidTimeRangeError,
  currentDayOverlappedStatus,
  currentDayInvalidTimeValueError,
  availableTimeTypeData,
  handleChangeAvailableTimeType,
}) => {
  const worktimeArray = dayData.worktimes;
  const onAddMoreClick = () => {
    handleAddAvailabilityTime(dayIndex);
  };

  const onClearTimeClick = (timeIndex: number) => {
    handleClearTime(dayIndex, timeIndex);
  };

  const onTimePick = (value: string, dataIndex: number, type: 'from' | 'to') => {
    handlePickTime(dayIndex, value, dataIndex, type);
  };

  const isWorkTimeExist = availableTimeTypeData === 'anytime' || (worktimeArray && worktimeArray.length > 0);
  const isDayAvailable = dayData.availability;

  const onAvailableTimeRadioChange = useCallback((v: AvailableTimeType) => {
    handleChangeAvailableTimeType(v, dayIndex);
  }, []);

  return (
    <Row className={`${isDayAvailable ? 'gx-mb-3' : 'gx-mb-1'}`} key={currentDay}>
      <Col className='gx-p-0' span={24} sm={7} xl={6} xxl={5}>
        <InputComponent
          name={`${dayIndex}`}
          type={INPUT_TYPE.SWITCH}
          label={capitalize(currentDay)}
          labelType={LABEL_TYPE.right}
          labelStyle={{ marginLeft: '15px' }}
          onChange={(v: boolean) => {
            handleAvailabilitySwitchChange(v, dayIndex);
          }}
          value={dayData.availability}
        />
      </Col>
      {dayData.availability && (
        <Col span={24} sm={17} xl={18} xxl={19} style={{ paddingLeft: 16 }}>
          <InputComponent
            name={`${dayIndex}`}
            type={INPUT_TYPE.RADIO}
            inputSettings={availableTimeTypeRadionputSettings}
            value={availableTimeTypeData}
            onChange={onAvailableTimeRadioChange}
            inputOptions={availableTimeTypeOptions}
            // value={dayData.availability}
          />
        </Col>
      )}
      {dayData.availability && availableTimeTypeData === 'specific' && (
        <>
          <Col className='gx-p-0' span={0} sm={7} xl={6} xxl={5} />
          <AvailabilityTimesContainerStyled span={24} sm={17} xl={18} xxl={19}>
            {!isWorkTimeExist && (
              <Col className='gx-mb-4'>
                <WarningMessageContainerStyled align='middle'>
                  <Col className='gx-p-0 gx-mr-2'>
                    <WarningMessageStyled>
                      <IntlMessages id='userProfile.availability.timeEmptyWarning' />
                    </WarningMessageStyled>
                  </Col>
                  {!worktimeArray.length && (
                    <Col className='gx-p-0'>
                      <ActionButtonStyled
                        $isBaseAddButton
                        style={{ padding: '0 30px' }}
                        type='dashed'
                        onClick={onAddMoreClick}>
                        <span style={{ fontSize: '16px' }}>+&nbsp;</span>
                        <span>
                          <IntlMessages id='userProfile.addRow' />
                        </span>
                      </ActionButtonStyled>
                    </Col>
                  )}
                </WarningMessageContainerStyled>
              </Col>
            )}

            <AvailabilityDayForm
              onTimePick={onTimePick}
              onClearTimeClick={onClearTimeClick}
              onAddMoreClick={onAddMoreClick}
              times={dayData.worktimes}
              currentDayOverlappedStatus={currentDayOverlappedStatus}
              currentDayInvalidTimeRangeError={currentDayInvalidTimeRangeError}
              currentDayInvalidTimeValueError={currentDayInvalidTimeValueError}
            />
          </AvailabilityTimesContainerStyled>
        </>
      )}
    </Row>
  );
};

export default AvailabilityDay;
